import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "app/store";
import { ApiResponse } from "models";

const initialState: any = {
  brandChartloading: false,
  SalesChartLoading: false,
  brandChartData: {},
  salesChartData: {},
  orderChartData: {},
  message: "",
  success: false,
  profileimageUrl: "",
  updateMessage: "",
  addcustomerloading: false,
  updateloading: false,
  deletecustomerloading: false,
};

const dashBoardSlice = createSlice({
  name: "dashBoard",
  initialState,
  reducers: {
    getBrandChartDataRequest(state, action: PayloadAction<ApiResponse>) {
      state.brandChartloading = true;
      state.message = "";
    },
    getBrandChartDataSuccess(state, action: PayloadAction<ApiResponse>) {
      state.brandChartloading = false;
      state.brandChartData = action.payload;
      state.success = action.payload.success;
    },
    getBrandChartDataFailed(state, action: PayloadAction<ApiResponse>) {
      state.brandChartloading = false;
      state.message = action.payload.message;
      state.success = action.payload.success;
    },
    getSalesChartDataRequest(state, action: PayloadAction<ApiResponse>) {
      state.SalesChartLoading = true;
      state.message = "";
    },
    getSalesChartDataSuccess(state, action: PayloadAction<ApiResponse>) {
      state.SalesChartLoading = false;
      state.salesChartData = action.payload;
      state.success = action.payload.success;
    },
    getSalesChartDataFailed(state, action: PayloadAction<ApiResponse>) {
      state.SalesChartLoading = false;
      state.message = action.payload.message;
      state.success = action.payload.success;
    },
    getOrderChartDataRequest(state, action: PayloadAction<ApiResponse>) {
      state.SalesChartLoading = true;
      state.message = "";
    },
    getOrderChartDataSuccess(state, action: PayloadAction<ApiResponse>) {
      state.SalesChartLoading = false;
      state.orderChartData = action.payload;
      state.success = action.payload.success;
    },
    getOrderChartDataFailed(state, action: PayloadAction<ApiResponse>) {
      state.SalesChartLoading = false;
      state.message = action.payload.message;
      state.success = action.payload.success;
    },

    clearData(state) {
      state.loading = false;
      state.message = "";
      state.success = false;
      state.updateMessage = "";
      state.deleteMessage = "";
      state.profileimageUrl = "";
      state.frontIdimageUrl = "";
      state.backIdimageUrl = "";
      state.frontidimgloading = "";
      state.backidimgloading = "";
    },
  },
});

//Actions
export const dashBoardActions = dashBoardSlice.actions;

//Selectors
export const getBrandChartData = (state: RootState) =>
  state.dashBoard.brandChartData;
export const getSalesChartData = (state: RootState) =>
  state.dashBoard.salesChartData;
export const getOrderChartData = (state: RootState) =>
  state.dashBoard.orderChartData;
export const getBrandChartLoading = (state: RootState) =>
  state.dashBoard.brandChartloading;

//Reducers
const dashBoardReducer = dashBoardSlice.reducer;
export default dashBoardReducer;
